
























































































































































import { Component, Inject, Mixins } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import VueScrollTo from 'vue-scrollto';
import isAuthorized from '@/mixins/isAuthorized';
import { mapActions } from 'vuex';
import { namespace } from 'vuex-class';
import { MetaInfo } from 'vue-meta';
import {
  Breadcrumbs as BreadcrumbsLayout,
  Extra as ExtraLayout,
} from '@/components/layout';
import VacancyRespondForm from '../form';
import ButtonCanRequest from '@/presets/button/can-request';
import PageError from '@/pages/404.vue';
import breadcrumbsMixin from '../mixins/breadcrumbs-mixin';
import { FETCH_ITEM, STORE_MODULE_NAME } from './consts';
import createStoreModule from './store';
import {
  AppText,
  AppList,
  AppHeading,
  AppPicture,
  AppWrapper,
  AppTypeIcon,
  AppCardsList,
  AppHtmlRender,
  AppRouterLink,
  AppBlockWrapper,
  AppCardTotalLayout,
  AppHeadingTextBlock,
  AppCardOneGridLayout,
  AppCardDescriptionBlockLayout,
} from '@/uikit';
import { VacancySidebar, VacancyMain, vacanciesService } from '@/services';
import Slider from "@/pages/vacancies/slider/Slider.vue";
import VacancyRespondFormModalBody from '@/components/ordersProcessForms/vacancy/VacancyRespondFormModalBody.vue';

const Vacancy = namespace(STORE_MODULE_NAME);
const actions = mapActions(STORE_MODULE_NAME, [FETCH_ITEM]);
const fetch = actions[FETCH_ITEM];

@Component({
  components: {
    Slider,
    AppText,
    AppList,
    PageError,
    AppPicture,
    AppHeading,
    AppWrapper,
    ExtraLayout,
    AppTypeIcon,
    AppCardsList,
    AppHtmlRender,
    AppRouterLink,
    AppBlockWrapper,
    ButtonCanRequest,
    BreadcrumbsLayout,
    AppCardTotalLayout,
    VacancyRespondForm,
    AppHeadingTextBlock,
    AppCardOneGridLayout,
    AppCardDescriptionBlockLayout,
  },
  inject: ['$api'],
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,
  data() {
    return {
      imgs: [],
    };
  },
  metaInfo(): MetaInfo {
    const {
      vacancy: { vacancy },
    } = this.$store.state;
    return {
      title: (vacancy && vacancy.name) || 'Вакансия',
    };
  },
  created() {
    this.$nextTick(() => {
      const params = {
        ...this.$route.query,
        ...this.$route.params,
      };
      const context = { $store: this.$store };
      fetch.call(context, params.id);
    });
  },
  watch: {
    id(newValue) {
      this.updateImages(newValue);
    },
  },
  methods: {
    async updateImages(id) {
      const { data } = await this.$api.get(`vacancy-images/${this.$store.state.vacancy.vacancy.id}`);
      if (data && data.data) {
        this.imgs = data.data.map((img: any) => {
          return {
            img: img.url,
            show: false,
          };
        });
      }
      if (this.imgs.length) {
        this.imgs[0].show = true;
      }
    },
  },
})
export default class VacancyCard extends Mixins(
  breadcrumbsMixin,
  isAuthorized
) {
  @Inject() $api: AxiosInstance;

  @Vacancy.State nothingFound: boolean;

  @Vacancy.State(({ vacancy }) => vacancy ? vacancy.id : undefined) id: string;
  @Vacancy.State(({ vacancy }) => vacancy ? vacancy.name : undefined) name: string;
  @Vacancy.State(({ vacancy }) => vacancy ? vacancy.salary : undefined) salary: string;
  @Vacancy.State(({ vacancy }) => vacancy ? vacancy.main : undefined) main: VacancyMain;
  @Vacancy.State(({ vacancy }) => vacancy ? vacancy.sidebar : undefined)
  sidebar: VacancySidebar;

  speed = 500;
  easing = 'ease-in-out';
  isRespondForm = false;
  isMessage = false;
  isLoading = false;
  isError = false;
  errorMessage = '';

  get crumbs() {
    const { name, breadcrumbs } = this;
    if (!name) return breadcrumbs;
    return breadcrumbs.concat([{ text: name }]);
  }

  get getRouterData() {
    const id = this.sidebar.partnerId;
    const url = this.$router.resolve({
      name: 'organization',
      params: { id },
    });
    return url.href;
  }

  get getImpossibleText() {
    if (!this.isAuthorized) {
      return 'Авторизуйтесь';
    } else if (!this.userCanCreateOrder) {
      return 'Вы уже оставили отклик на эту вакансию';
    } else {
      return 'Запись приостановлена';
    }
  }

  get getFactor() {
    if (this.isAuthorized && !this.userCanCreateOrder) {
      return 1.0;
    }
    return 1.4;
  }

  get userCanCreateOrder(): boolean {
    return (
      !!this.$store.state.vacancy &&
      !!this.$store.state.vacancy.vacancy &&
      !!this.$store.state.vacancy.vacancy.user_can_create_order
    );
  }

  get isActive(): boolean {
    return this.isAuthorized && this.userCanCreateOrder;
  }

  // asyncData({ store, route }: Context): Promise<any> {
  //   const context = { $store: store };
  //   const params = {
  //     ...route.query,
  //     ...route.params,
  //   };
  //
  //   return fetch.call(context, params.id);
  // }

  onRespond(): void {
    this.showRequest();
  }

  showRequest() {
    this.$ui.$modal.show('VacancyRespondFormBody',{
      settings: {
        size: {
          width: '710px',
          minHeight: '500px',
          height: 'auto'
        },
        title: 'Отклик на вакансию',
      },
      bind: this,
      slots: {
        body: {
          component: VacancyRespondFormModalBody,
          propsData: {
            isError: this.isError
          },
        },
      },
    })
  }

  async submitRespond(data: any) {
    if (!this.id) return;
    const result = {
      vacancy_id: this.id,
      cover_letter: data!.text || '',
      resume_file: data.files.name.length ? data.files : '',
    };

    this.isLoading = true;

    try {
      const res = await vacanciesService(this.$api).postVacancyFeedback(result);
      const context = { $store: this.$store };
      const params = {
        ...this.$route.query,
        ...this.$route.params,
      };
      await fetch.call(context, params.id);
      this.isMessage = true;
      this.isLoading = false;
    } catch (err) {
      const [{ msg }] = err.response.data.errors;

      if (msg) this.errorMessage = msg;
      this.isMessage = true;
      this.isError = true;
      this.isLoading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/vacancies/card/VacanciesCard.vue